import React from 'react';

import PropTypes from 'prop-types';

import {
    Content,
    ContentSection,
    MarkdownContent,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import placeGuideConfig from '../../../../config/placeguide.locale';

function MainStations(props) {
    const {
        t,
        className,
    } = props;

    return (
        <ContentSection
            className={className}
            id="place-guide-main-stations"
            title={t('mainStationsTitle')}
            isCollapsable
            useAccordionComponent
        >
            <Content>
                <MarkdownContent>
                    {t('mainStationsDescription')}
                </MarkdownContent>
            </Content>
        </ContentSection>
    );
}

MainStations.propTypes = {
    className: PropTypes.string,
    t: PropTypes.func,
};

export {
    MainStations,
};

export default localize(MainStations, placeGuideConfig.namespace);
